/*
 * Decrypt key Loader
 */

import Event from './hlsjs/events';
import EventHandler from './hlsjs/event-handler';
import { ErrorTypes, ErrorDetails } from './hlsjs/errors';
//import { logger } from './hlsjs/utils/logger';

/**
* @access internal
*/
class CustomKeyLoader extends EventHandler {

	/**
	 * constructor
	 *
	 * @param {Hls} hlsJs - the hlsJs instance
	 * @param {KeyLoadCallback} keyLoaderCallback - the keyload callback to call { context, callbacks }
	 */
	constructor(hlsJs, keyLoaderCallback ) {
		super(hlsJs, Event.KEY_LOADING);
		this._disposed = false;
		this._keyLoaderCallback = keyLoaderCallback;

		// this overrides the keyLoader with one that returns the bourne key.
		//this._keyLoaderCallback = this._bourneKeyLoadCallback;

		this._decryptkey = null;
		this._decrypturl = null;
	}

	destroy() {
		this._disposed = true;
		this._keyLoadCallback = null;
		this._decryptkey = null;
		this._decrypturl = null;

		EventHandler.prototype.destroy.call(this);
	}

	/**
	 * a simple callback tester function.
	 *
	 * @param {Object} context
	 * @param {Object} callbacks
	 */
	_bourneKeyLoadCallback( context, callbacks ) {
		const bourneKey = [0x5D, 0x8C, 0x1E, 0xE7, 0x0E, 0x6F, 0x4E, 0xEB,
			0x4D, 0x6E, 0xB0, 0x50, 0x3B, 0xAD, 0x4D, 0x6F];

		let key = new Uint8Array(bourneKey);
		//callbacks.onTimeout();
		//callbacks.onError(null, new Error('Oh Dear!'));
		callbacks.onSuccess(key);
	}

	onKeyLoading(data) {
		if( !this._disposed ) {
			let frag = data.frag;
			let decryptdata = frag.decryptdata;
			let uri = decryptdata.uri;

			// if uri is different from previous one or if decrypt key not retrieved yet
			if (uri !== this._decrypturl || this._decryptkey === null) {
				this._decrypturl = uri;
				this._decryptkey = null;

				let context = {
					url: uri,
					frag: frag,
				};

				let callbacks = {
					onSuccess: this._doSuccess.bind(this, context),
					onError: this._doError.bind(this, context),
					onTimeout: this._doTimeout.bind(this, context),
				};

				// call the client's keyLoader callacbl
				this._keyLoaderCallback( context, callbacks );
			}
			else if (this._decryptkey) {
				// we already loaded this key, return it
				decryptdata.key = this._decryptkey;
				this.hls.trigger(Event.KEY_LOADED, { frag: frag });
			}
		}
	}

	/**
	 * called with key data upon success
	 *
	 * @param {Object} context - the loader context, which is bound at creation.
	 * @param {Uint8Array} key - the 16 bytes of key data. must be valid.
	 */
	_doSuccess(context, key) {
		if(!this._disposed) {
			let frag = context.frag;

			// verify key
			this._decryptkey = frag.decryptdata.key = key;

			this.hls.trigger(Event.KEY_LOADED, {
				frag: frag,
			});
		}
	}

	/**
	 * called with a response object on failure.
	 *
	 * @param {Object} context - the loader context, which is bound at creation.
	 * @param {[response]} key - xhr like response... or not.
	 * @param {[Error]} error - error object, if applicable.
	 */
	_doError(context, response, error ) {
		if( !this._disposed ) {
			let data = {
				type: ErrorTypes.NETWORK_ERROR,
				details: ErrorDetails.KEY_LOAD_ERROR,
				fatal: false,
				frag: context.frag,
				response: response,
				err: error,
			};

			this.hls.trigger(Event.ERROR, data );
		}
	}

	/**
	 * called with a response object on failure.
	 *
	 * @param {Object} context - the loader context, which is bound at creation.
	 * @param {[response]} key - xhr like response... or not.
	 */
	_doTimeout(context) {
		if( !this._disposed ) {
			this.hls.trigger(Event.ERROR, {
				type: ErrorTypes.NETWORK_ERROR,
				details: ErrorDetails.KEY_LOAD_TIMEOUT,
				fatal: false,
				frag: context.frag,
			});
		}
	}
}

export default CustomKeyLoader;



// WEBPACK FOOTER //
// ./src/CustomKeyLoader.js